/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Security_Rest_DescInputs */

const es_privacy_policy_security_rest_desc = /** @type {(inputs: Privacy_Policy_Security_Rest_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AES-256-GCM para todos los datos personales almacenados, incluyendo credenciales, metadata y contenido procesado.`)
};

const en_privacy_policy_security_rest_desc = /** @type {(inputs: Privacy_Policy_Security_Rest_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AES-256-GCM for all stored personal data, including credentials, metadata, and processed content.`)
};

/**
* | output |
* | --- |
* | "AES-256-GCM for all stored personal data, including credentials, metadata, and processed content." |
*
* @param {Privacy_Policy_Security_Rest_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_security_rest_desc = /** @type {((inputs?: Privacy_Policy_Security_Rest_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Security_Rest_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_security_rest_desc(inputs)
	return en_privacy_policy_security_rest_desc(inputs)
});
export { privacy_policy_security_rest_desc as "privacy_policy.security.rest_desc" }